/** Nada de `'es'` fijo: era exactamente el error que esto viene a quitar. */
const INTL_LOCALE = {
    es: 'es',
    en: 'en',
};
/**
 * El locale que le toca a un idioma, para quien necesite su propio `Intl`.
 *
 * `formatters` cubre los cuatro formatos que se repiten, pero hay pantallas con
 * uno propio —el eje de una gráfica quiere «4 ago», una cita quiere «mar 15 de
 * sep»— y sin esto acababan escribiendo `'es'` a mano. Que es como el panel en
 * inglés terminó enseñando fechas en español.
 *
 * Se expone el locale y no un formateador más porque las opciones son de cada
 * pantalla: lo único que no puede decidir cada una es el IDIOMA.
 */
export function intlLocale(language) {
    return INTL_LOCALE[language];
}
const RELATIVE_UNITS = [
    ['year', 31_536_000],
    ['month', 2_592_000],
    ['day', 86_400],
    ['hour', 3_600],
    ['minute', 60],
];
function toDate(value) {
    if (value === null || value === undefined || value === '')
        return null;
    const date = value instanceof Date ? value : new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
}
export function formatters(language) {
    const locale = INTL_LOCALE[language];
    return {
        dateTime: (value) => {
            const date = toDate(value);
            /* Un guion y no una cadena vacía: una celda en blanco parece un fallo de
               carga, y un guion dice «aquí no hay fecha». */
            if (!date)
                return '—';
            return date.toLocaleDateString(locale, {
                day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit',
            });
        },
        date: (value) => {
            const date = toDate(value);
            if (!date)
                return '—';
            return date.toLocaleDateString(locale, { day: 'numeric', month: 'long', year: 'numeric' });
        },
        relative: (value) => {
            const date = toDate(value);
            if (!date)
                return null;
            const seconds = (date.getTime() - Date.now()) / 1000;
            const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' });
            for (const [unit, size] of RELATIVE_UNITS) {
                /* El minuto cierra la lista: por debajo se diría «hace 4 segundos», que
                   en una fecha de creación es ruido. */
                if (Math.abs(seconds) >= size || unit === 'minute') {
                    return rtf.format(Math.round(seconds / size), unit);
                }
            }
            return null;
        },
        number: (value) => new Intl.NumberFormat(locale).format(value),
    };
}
//# sourceMappingURL=format.js.map